import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  horizontalStepperStyle: {
    marginBottom: 20,
    marginTop: 30,
  },
  stepsContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  stepContainerStyle: {
    flexDirection: 'column',
  },
  titlesContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
});
